import { AddEditReportUserFormFields, IAddOrEditUsersProps, IReportUserRecord, TUserCreds } from '@/ts/common-types';
import { reportUsersFormRules } from '@/ts/constants';
import { showToast } from '@/ts/modals';
import { addReportUser, updateReportUser } from '@/ts/utils';
import { Button, Col, Form, Input, Row } from 'antd'
import React, { useEffect, useState } from 'react'



const AddOrEditReportUsers =
    ({ addUsersDisplay, editUserDisplay, setEditUserDisplay, setUpdateRecords, isEdit, record }: IAddOrEditUsersProps) => {

        const [loading, setLoading] = useState(false);
        const [error, setError] = useState(null);

        const [form] = Form.useForm();

        useEffect(() => {
            if (!addUsersDisplay || !editUserDisplay) {
                form.resetFields();
                setError(null);
            }

            if (isEdit) {
                form.setFieldValue(AddEditReportUserFormFields.USER_NAME, record.username);
                form.validateFields([AddEditReportUserFormFields.USER_NAME]);
            }
        }, [addUsersDisplay, editUserDisplay, isEdit, record]);


        const handleFormSubmit = async (values: { userName: string, password: string }) => {
            try {
                setError(null)
                setLoading(true);

                let response;

                if (!isEdit) {
                    response = await addReportUser({ userName: values.userName.trim(), password: values.password.trim() });
                } else {
                    response = await updateReportUser({ userId: record.id, userName: values.userName.trim(), password: values.password.trim() });
                }

                if (!response.status) {
                    setLoading(false);
                    setError(response.message)
                } else {
                    showToast(
                        "success",
                        response.message
                    );
                    form.resetFields();
                    if (isEdit) {
                        setEditUserDisplay(false);
                    }
                    setUpdateRecords((prev => !prev));
                }
                setLoading(false);
            } catch (err) {

                setLoading(false);
                showToast("danger", "Error creating user");
            }
        }

        const formInitialValues: { userName: string, password: string } = {
            userName: "",
            password: ""
        };

        return (
            <div>
                <h5>{!isEdit ? "Add User" : ""}</h5>
                <div className="card bg-light admin-settings-container">
                    <Row>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={handleFormSubmit}
                            initialValues={formInitialValues}
                        >
                            <Row >
                                <Col span={20}>
                                    <Form.Item
                                        label="User Name"
                                        name="userName"
                                        rules={reportUsersFormRules.userName}
                                    >
                                        <Input
                                            className="border"
                                            placeholder="Enter user name"
                                        />
                                    </Form.Item>
                                </Col>
                                <Col span={20}>
                                    <Form.Item
                                        label="Password"
                                        name="password"
                                        rules={reportUsersFormRules.password}
                                    >
                                        <Input
                                            className="border"
                                            placeholder="Enter password"
                                            type="password"
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>
                            {
                                error && (
                                    <Row >
                                        <Col span={20}><p className="text-danger">{error ? error : ""}</p></Col>
                                    </Row>
                                )
                            }

                            <Row>
                                <Form.Item>
                                    <Button
                                        type="primary"
                                        loading={loading}
                                        htmlType="submit"
                                    >
                                        {loading ? `${!isEdit ? "Saving..." : "Saving changes..."}` :
                                            `${!isEdit ? "Submit" : "Save changes"}`}
                                    </Button>
                                </Form.Item>
                            </Row>
                        </Form>
                    </Row>
                </div ></div>
        )
    }

export default AddOrEditReportUsers